import { useEffect } from 'react'
import images from '@assets/images'
import './BedroomModal.css'

// Map bedroomType → { label, image }
const BEDROOM_CONFIG = {
  '1PN': {
    label: '1 Phòng Ngủ',
    image: images.bedroom1PN,
  },
  '1PN+': {
    label: '1 Phòng Ngủ + 1',
    image: images.bedroom1PNPlus,
  },
  '1PN_GOC': {
    label: '1 Phòng Ngủ + Góc',
    image: images.bedroom1PNGoc,
  },
  '2PN': {
    label: '2 Phòng Ngủ',
    image: images.bedroom2PN,
  },
  '2PN_2': {
    label: '2 Phòng Ngủ Loại 2',
    image: images.bedroom2PN2,
  },
}

/**
 * BedroomModal — hiển thị mặt bằng căn khi user click vào SVG path
 * Layout: cột trái = thông tin, cột phải = ảnh mặt bằng
 * Đóng bằng: click backdrop hoặc phím Escape
 */
function BedroomModal({ apt, onClose }) {
  useEffect(() => {
    if (!apt) return
    const onKey = (e) => { if (e.key === 'Escape') onClose() }
    document.addEventListener('keydown', onKey)
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.removeEventListener('keydown', onKey)
      document.body.style.overflow = prev
    }
  }, [apt, onClose])

  if (!apt) return null

  const config = BEDROOM_CONFIG[apt.bedroomType] ?? {
    label: apt.bedroomType ?? 'Căn hộ',
    image: images.bedroom1PNPlus,
  }

  const formatArea = (val) => {
    return typeof val === 'number' ? val.toFixed(2).replace('.', ',') : val
  }

  const specs = [
    { label: 'Mã căn',                value: apt.maCan },
    { label: 'Tháp',                  value: apt.block === 'A' ? 'Tháp A' : 'Tháp B' },
    { label: 'Diện tích tim tường',   value: `${formatArea(apt.timTuong)} m²` },
    { label: 'Diện tích thông thủy',  value: `${formatArea(apt.thongThuy)} m²` },
  ]

  return (
    <div
      className="bedroom-modal__backdrop"
      role="dialog"
      aria-modal="true"
      aria-label={`Mặt bằng ${config.label}`}
      onClick={onClose}
    >
      {/* Card — click bên trong không đóng */}
      <div
        className="bedroom-modal__card"
        onClick={(e) => e.stopPropagation()}
      >
        {/* CỘT TRÁI — thông tin */}
        <div className="bedroom-modal__info">
          <h2 className="bedroom-modal__info-title">{config.label}</h2>

          <dl className="bedroom-modal__specs">
            {specs.map((s) => (
              <div key={s.label} className="bedroom-modal__spec-row">
                <dt className="bedroom-modal__spec-label">{s.label}</dt>
                <dd className="bedroom-modal__spec-value">{s.value}</dd>
              </div>
            ))}
          </dl>
        </div>

        {/* CỘT PHẢI — ảnh mặt bằng */}
        <div className="bedroom-modal__img-wrap">
          <img
            src={config.image}
            alt={`Mặt bằng ${config.label}`}
            className="bedroom-modal__img"
            draggable={false}
          />
        </div>
      </div>
    </div>
  )
}

export default BedroomModal
